import { render, staticRenderFns } from "./reader-writer-text-analysis.vue?vue&type=template&id=24cd8d88&scoped=true"
import script from "./reader-writer-text-analysis.ts?vue&type=script&lang=ts&external"
export * from "./reader-writer-text-analysis.ts?vue&type=script&lang=ts&external"
import style0 from "./reader-writer-text-analysis.less?vue&type=style&index=0&id=24cd8d88&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cd8d88",
  null
  
)

export default component.exports